import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, concatMap, take } from 'rxjs';

import { NormalizeAddress } from '../interfaces/normalize-address';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  deleteAddress(id: number) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Vendor: () =>
            this.http.delete(
              `/api/v2/vendor/${this.AuthService.getUserVendorId()}/address/${id}/deleteAddress`
            ),
          Client: () =>
            this.http.delete(
              `/api/v2/client/${this.AuthService.getUserCompanyId()}/address/${id}/deleteAddress`
            ),
          Admin: () =>
            this.http.delete(`/api/v2/admin/address/${id}/deleteAddress`)
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        this.ToastService.addErrorToast('Error', 'Invalid permission.');
        throw new Error('Invalid permission.');
      })
    );
  }

  batchVerifyAddresses(addressRequests: NormalizeAddress[]) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<NormalizeAddress[]>;
        } = {
          Client: () =>
            this.http.post<NormalizeAddress[]>(
              '/api/v3/addresses/batch-verify-addresses',
              addressRequests
            ),
          Admin: () =>
            this.http.post<NormalizeAddress[]>(
              '/api/v3/addresses/batch-verify-addresses',
              addressRequests
            )
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        this.ToastService.addErrorToast('Error', 'Invalid permission.');
        throw new Error('Invalid permission.');
      })
    );
  }
}
